import React, { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import Layout from './components/Layout'
import ScrollToTop from './components/ScrollToTop'
import AppRoutes from './routes/AppRoutes'
import { clearLegacyStorage } from './helpers/legacyStorage'
import { loadCategories } from './services/categoriesService'

const App = () => {
    useEffect(() => {
        // Once at start-up: the old demo mode flag is no longer read.
        clearLegacyStorage()
        loadCategories()
    }, [])

    // PUBLIC_URL comes from package.json "homepage" ("/", so empty: the app
    // is served at the host root), the same place nginx and the ingress serve
    // it, so the router cannot drift from where the assets are.
    return (
        <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
            <ScrollToTop />
            <Layout>
                <AppRoutes />
            </Layout>
        </BrowserRouter>
    )
}

export default App
